import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import useProductContent from '@/composables/useProductContent/useProductContent';
import BaseScrollContainer from '~/components/Layout/BaseScrollContainer.vue';
import RenderContent from '~/components/cms/page/RenderContent.vue';
export default defineComponent({
  name: 'BlockSimpleTabContainer',
  components: {
    BaseScrollContainer: BaseScrollContainer,
    AzButton: AzButton,
    AzIcon: AzIcon,
    RenderContent: RenderContent
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    catchphrase: {
      type: String,
      default: ''
    },
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    var currentActiveTabIndex = ref(0);
    var components = computed(function () {
      return props.tabs ? mapComponentName(props.tabs) : [];
    });
    var currentTab = computed(function () {
      return components.value[currentActiveTabIndex.value];
    });
    var setCurrentTab = function setCurrentTab(index) {
      currentActiveTabIndex.value = index;
    };
    return {
      isMobile: isMobile,
      components: components,
      currentActiveTabIndex: currentActiveTabIndex,
      currentTab: currentTab,
      setCurrentTab: setCurrentTab
    };
  }
});